import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 import PaginationTable from '../../pagination/Pagination4';


// const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const  FPS_RO_data = async (params) => { 
        const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/FPS_RO_Report`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const FPS_RO_Report = ({ trans_date, dist_code, dist_name ,office_code,afso_name, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
     const detailsLoadFPS = useRef(null);  
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchQuery, setSearchQuery] = useState('');
   

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await  FPS_RO_data({trans_date , dist_code ,office_code});
               
                if (Array.isArray(response_data.data)) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                console.log(error);

                setError(error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [trans_date, dist_code ,office_code]);

    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
        setPage(0);  
    };

    const filteredData = reportData.filter(item =>
        item.truckchitno.toLowerCase().includes(searchQuery.toLowerCase())
    );

     const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);    

    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsLoadFPS.current) {
            detailsLoadFPS.current.scrollIntoView({ behavior: 'smooth' , block: 'center'});
            // const elementPosition = detailsLoaddd.current.offsetTop;
            // window.scrollTo({
            //     top: elementPosition,
            //     behavior: 'smooth'
            // });
         }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    } 

    return (
        <>
   <br /><br />
            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'end', marginBottom: '20px', marginRight: '15%' }}>
                <input
                    type="text"
                    placeholder="Search Truck Chit No."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ padding: '8px', width: '300px' }}
                />
            </div>
            <br />

            <table align="center" width="90%" border={1}  ref={detailsLoadFPS}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={19}>
                        <font  style={{color: 'orange'}} > {dist_name} </font>/
                        <font  style={{color: 'orange'}} > {afso_name} </font>
                       {heading} on 
                        <font  style={{color: 'orange'}} > {trans_date} </font>                         </th>
                    </tr>
                    <tr className="tableheader">
                        <th >Sl.No</th>
                        <th >FPS Id</th>
                        <th >Commodity</th>
                        <th >Scheme</th>
                        <th >Dispatched<br/>Qty</th>
                        <th>Status</th>
	                    <th>Truck Chit<br/>No</th>
	                    <th>Allocation<br/>Order No</th>
	                    <th>Dispatched<br/>Date</th>
	                    <th>Received<br/>Date</th>
	                </tr>	
                    
                </thead>
                <tbody>
                    {paginatedData.map((item, index) => (
                        <tr  >
                            <td style={{ textAlign: 'center' }}>   {rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                                 {item.fps_id}
                            </td>
                            <td style={{ textAlign: 'left' }}>{item.comm_name}</td>
                            <td style={{ textAlign: 'left' }}>{item.scheme_name_en}</td>
                            <td style={{ textAlign: 'right' }}>{item.dispatched}</td>
                            <td style={{ textAlign: 'left' }}>{item.status}</td>
                            <td style={{ textAlign: 'left' }}>{item.truckchitno}</td>
                            <td style={{ textAlign: 'left' }}>{item.allocation_orderno}</td>
                            <td style={{ textAlign: 'left' }}>{item.entry_date}</td>
                            <td style={{ textAlign: 'left' }}>{item.updated_time}</td>
                        </tr>
                    ))}
                </tbody>
               
            </table> <br /><br />
            <div width="75%" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '90%' , marginBottom : '5%'  }}>
                <PaginationTable
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        
        </>
    );
};

export default FPS_RO_Report;
